export default __webpack_public_path__ + "static/media/kitchen-2.e95bfde9.jpg";